import { useModoConsultaEvaluacion } from '../../../../hooks/useModoConsultaEvaluacion';
import React, { useState, useContext, useEffect, useRef } from 'react';
import styles from './Ejercicio9.module.scss';
import { db } from '../../../../firebase/firebase';
import { collection, addDoc } from 'firebase/firestore';
import { AppContext } from '../../../../Context';
import Swal from 'sweetalert2';

const Ejercicio9 = ({ cerrarModal }) => {
  const { currentUser } = useContext(AppContext);
    const modoConsulta = useModoConsultaEvaluacion();
  const [currentStep, setCurrentStep] = useState(1);
  const [timer, setTimer] = useState(120);
  const avisoTiempo = useRef(false);
  const [enviando, setEnviando] = useState(false);

  const examplePiramide = [
    [1045],
    [495, 550],
    [233, 262, 288],
    [112, 121, 141, 147],
    [58, 54, 67, 74, 73],
    [34, 24, 30, 37, 37, 36],
    [20, 14, 10, 20, 17, 20, 16],
    [6, 14, 0, 10, 10, 7, 13, 3]
  ];

  const [piramideOne, setPiramideOne] = useState([
    ["796"],
    ["", ""],
    ["", "", "189"],
    ["", "106", "", ""],
    ["", "", "62", "", ""],
    ["14", "", "", "", "16", ""],
    ["", "", "", "", "11", "", ""],
    ["", "", "", "10", "", "", "", ""]
  ]);

  const [piramideTwo, setPiramideTwo] = useState([
    [685],
    ["", ""],
    ["", 159, ""],
    ["", "", "", ""],
    ["", 64, "", 25, ""],
    [44, "", "", 12, "", ""],
    ["", "", 15, "", "", "", ""],
    ["", "", "", "", "", 1, "", ""]
  ]);

  useEffect(() => {
    if (currentStep !== 2 && currentStep !== 3) return undefined;
    if (timer > 0) {
      const interval = setInterval(() => setTimer(prev => Math.max(0, prev - 1)), 1000);
      return () => clearInterval(interval);
    }
    if (!avisoTiempo.current) {
      avisoTiempo.current = true;
      Swal.fire({
        icon: 'info',
        title: 'Tiempo agotado',
        text: 'Tus respuestas se conservan. Puedes revisarlas y completar la pirámide antes de continuar.',
        confirmButtonText: 'Continuar'
      });
    }
    return undefined;
  }, [currentStep, timer]);

  const handleChange = (value, setPiramide, index, subIndex) => {
    if (value.length <= 3 && /^\d*$/.test(value)) {
      setPiramide(piramide => {
        const newPiramide = piramide.map(fila => [...fila]);
        newPiramide[index][subIndex] = value;
        return newPiramide;
      });
    }
  };

  const allFieldsFilled = (piramide) => {
    return piramide.every(level => level.every(value => value.toString().trim() !== ''));
  };

  const goToStep = (step) => {
    setCurrentStep(step);
    avisoTiempo.current = false;
    setTimer(120);
  };

  async function advanceStep(nextStep) {
    if (modoConsulta) { if (nextStep >= 4) cerrarModal?.(); else goToStep(nextStep); return; }

    if (enviando) return;
    if (nextStep === 3 && !allFieldsFilled(piramideOne)) {
      Swal.fire({
        icon: 'error',
        title: 'Campos Incompletos',
        text: 'Debe completar todos los campos de la pirámide antes de avanzar.',
        confirmButtonText: 'Aceptar'
      });
      return;
    }

    if (nextStep === 4 && !allFieldsFilled(piramideTwo)) {
      Swal.fire({
        icon: 'error',
        title: 'Campos Incompletos',
        text: 'Debe completar todos los campos de la pirámide antes de finalizar.',
        confirmButtonText: 'Aceptar'
      });
      return;
    }

    if (nextStep === 3) {
      if (!await sendResults(piramideOne, 'Pirámide 1')) return;
    }

    if (nextStep === 4) {
      if (!await sendResults(piramideTwo, 'Pirámide 2')) return;
      Swal.fire({
        title: '¡Ejercicio Finalizado!',
        text: 'Resultados enviados con éxito.',
        icon: 'success',
        confirmButtonText: 'Cerrar'
      }).then((result) => {
        if (result.isConfirmed) {
          cerrarModal();
        }
      });
      return;
    }

    setCurrentStep(nextStep);
    avisoTiempo.current = false;
    setTimer(120); // Reset timer for the next step
  }

  const sendResults = async (piramideData, piramideName) => {
        if (modoConsulta) return true;

    setEnviando(true);
    try {
      const tiempoUsado = 120 - timer; // Calculate time taken
      await addDoc(collection(db, "evaluaciones"), {
        userId: currentUser.uid,
        [piramideName]: piramideData.flat(),
        tiempoUsado: tiempoUsado,
        nombre: `Ejercicio 9: ${piramideName}`,
        nivel: "Basico",
        modulo: "3",
        createdAt: new Date()
      });
      return true;
    } catch (error) {
      console.error("Error al enviar las respuestas: ", error);
      Swal.fire({
        icon: 'error',
        title: 'Error al enviar las respuestas',
        text: 'Hubo un error al enviar las respuestas.',
        confirmButtonText: 'Aceptar'
      });
      return false;
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className={styles.container}>
       <h3>Nivel Básico</h3>
      <h3>Módulo 3 - Ejercicio 9</h3>
      <h5>Ejercicio de Atención</h5>

      
      {/* Display content based on current step */}
      {currentStep === 1 && (
        <div>
          <p>Ponga mucha atención y hagalo lo más rapido posible</p>
          <p>Dispones de 2 minutos en cada practica, al momento de hacer clic se mostrará la primera pirámide que deberás completar. Al terminar el tiempo, tus respuestas se conservarán y podrás continuar</p>
          <p>Vamos a activar el pensamiento lógico. No anote nada en su registro de práctica</p>
          <h3><strong>Ejemplo</strong></h3>
          {examplePiramide.map((level, idx) => (
            <div key={idx} className={styles[`nivel${level.length}`]}>
              {level.map((num, index) => (
                <span key={index} className={styles.block}>{num}</span>
              ))}
            </div>
          ))}
          <button className="btn btn-primary" disabled={enviando} onClick={() => advanceStep(2)}>Completar pirámide 1</button>
        </div>
      )}
      {currentStep === 2 && (
        <div>
          <h3>Tiempo: {timer} segundos</h3>
          {timer === 0 && <p role="status">Tiempo agotado. Tus respuestas se conservan; puedes completarlas y continuar.</p>}
          <div className={styles.piramide}>
            {piramideOne.map((level, idx) => (
              <div key={idx} className={styles[`nivel${level.length}`]}>
                {level.map((num, index) => (
                  <input
                    key={index}
                    type="text"
                    className={`${styles.block} ${styles.inpute9}`}
                    value={num}
                    onChange={(e) => handleChange(e.target.value, setPiramideOne, idx, index)}
                    maxLength={3}
                  />
                ))}
              </div>
            ))}
          </div>
          <div className="d-flex gap-2 justify-content-center">
            <button className="btn btn-outline-secondary" disabled={enviando} onClick={() => goToStep(1)}>Volver</button>
            <button className="btn btn-primary" disabled={enviando} onClick={() => advanceStep(3)}>Completar pirámide 2</button>
          </div>
        </div>
      )}
      {currentStep === 3 && (
        <div>
          <h3>Tiempo: {timer} segundos</h3>
          {timer === 0 && <p role="status">Tiempo agotado. Tus respuestas se conservan; puedes completarlas y continuar.</p>}
          {piramideTwo.map((level, idx) => (
            <div key={idx} className={styles[`nivel${level.length}`]}>
              {level.map((num, index) => (
                <input
                  key={index}
                  type="text"
                  className={`${styles.block} form-control form-control-sm`}
                  value={num}
                  onChange={(e) => handleChange(e.target.value, setPiramideTwo, idx, index)}
                  maxLength={3}
                />
              ))}
            </div>
          ))}
          <div className="d-flex gap-2 justify-content-center">
            <button className="btn btn-outline-secondary" disabled={enviando} onClick={() => goToStep(2)}>Volver</button>
            <button className="btn btn-primary" disabled={enviando} onClick={() => advanceStep(4)}>Finalizar ejercicio</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Ejercicio9;
